import type {
  AdminDonationListItem,
  AdminNewsletterSubscriber,
} from "@/lib/admin-api-types";
import { getCategoryLabel } from "@/lib/donation-categories";

function escapeCsv(value: string | number | null | undefined): string {
  const str = value == null ? "" : String(value);
  if (/[",\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function donationsToCsv(donations: AdminDonationListItem[]): string {
  const headers = [
    "ID",
    "Donor",
    "Email",
    "Amount (INR)",
    "Category",
    "Type",
    "Status",
    "Receipt Number",
    "Payment ID",
    "Created At",
    "Paid At",
  ];
  const rows = donations.map((d) =>
    [
      d.id,
      d.donorName,
      d.email,
      d.amount,
      getCategoryLabel(d.category),
      d.type ?? "",
      d.status,
      d.receiptNumber ?? "",
      d.razorpayPaymentId ?? "",
      d.createdAt ?? "",
      d.paidAt ?? "",
    ]
      .map(escapeCsv)
      .join(",")
  );
  return [headers.join(","), ...rows].join("\n");
}

export function newsletterToCsv(subscribers: AdminNewsletterSubscriber[]): string {
  const headers = ["Email", "Subscribed At", "Status", "Unsubscribed At"];
  const rows = subscribers.map((sub) => {
    const active = !sub.unsubscribedAt;
    return [
      sub.email,
      sub.subscribedAt,
      active ? "Active" : "Unsubscribed",
      sub.unsubscribedAt ?? "",
    ]
      .map(escapeCsv)
      .join(",");
  });
  return [headers.join(","), ...rows].join("\n");
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
